import type AdminLink from '../../../../../types/AdminLink';
import { isFeatureEnabled } from '../../../services/Features';
import replacement, { type ReplacementKey } from '../../../services/Replacement';

export type LinkCategories = Record<string, AdminLink[]>;

const applyReplacement = (link: AdminLink): AdminLink => {
    if (link.nameType === 'REPLACEMENT') {
        return {
            ...link,
            name: replacement(link.name as ReplacementKey),
        };
    }
    return link;
};

const isFeatureEnabledForLink = (link: AdminLink) => {
    if (link.name === 'Glossary') {
        return isFeatureEnabled('FEATURE_glossary');
    }
    return true;
};

const isVisibleLink = (link: AdminLink) => link.visible && isFeatureEnabledForLink(link);

export const groupLinksByCategory = (links: AdminLink[]): LinkCategories =>
    links
        .filter(isVisibleLink)
        .map(applyReplacement)
        .reduce<LinkCategories>((categories, link) => {
            categories[link.category] = [...(categories[link.category] ?? []), link];
            return categories;
        }, {});

export const countAdminErrors = (links: AdminLink[]) => links.filter(link => link.status === 'ERROR').length;
